var RCM_STATUS = 0;
// render items when loaded
var onRecommendationsLoaded = function (data) {
    if (RCM_STATUS !== "TIMED_OUT") {
        RCM_STATUS = "LOADED";

        // render items ...
        if (data && data.length > 0) {
            var itemIds = [];
            var element = document.getElementById('recommendations__br_eng');
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                console.log('ITEM:',item);
                itemIds.push(item.item_id);
                const productCardEngagement = document.createElement("div");
                productCardEngagement.id = `bloom-product-card-${item.product_id}`;
                productCardEngagement.classList.add("product-card");
                productCardEngagement.classList.add("swiper-slide");
                const imagesCarouselId = `images-carousel-${item.product_id}`;
                const productLabel1 = item.tags_list.includes("product_label_1:new in") ? "New In" : "";

                productCardEngagement.innerHTML = `
                    <div class="product-main-content exp-reco-product" data-product-id="${item.item_id}">
                        ${productLabel1 != "" ? `<span class="card-tag">${productLabel1}</span>` : ""}
                        <div id="${imagesCarouselId}" class="product-images-carousel" style="overflow: hidden;">
                            <div class="product-images swiper-wrapper">
                                ${
                                    item._images_src_list.map((url) => `
                                    <div class="swiper-slide">
                                        <a href="${item.url}">
                                        <img
                                          width
                                          height
                                          alt="${item.title}"
                                          src="${url}&width=533"
                                          class="products-grid-item-media-image lazyload lazy-image"
                                          loading="lazy"
                                        >
                                        </a>
                                    </div>
                                    `
                                    )
                                    .join("")
                                }$
                            </div>
                        </div>
                    </div>

                    <div class="product-footer">
                        <div class="row-one">
                            <a href="${item.url}" class="full-unstyled-link card-title">
                                <h3 class="card-title-text">${item.title}</h3>
                            </a>
                            <!-- Traer los colores si puede ser de BR o investigar desde metafields o algo
                            ${item.count_colors ? `<span class="count-colors">${item.count_colors} color${item.count_colors > 1 ? 's' : ''}</span>` : ''} -->
                        </div>
                        <div class="row-two">
                        <!-- no habrá precio
                            <div class="price-container">
                                ${item.meta_product_management_style_discount ? 
                                    `<span class="regular-price">€${(item.price - (item.price * item.meta_product_management_style_discount)).toFixed(2)}</span>
                                        <span class="sale-price">€${item.price.toFixed(2)}</span>` : 
                                    `<span class="regular-price">€${item.price ? item.price.toFixed(2) : ''}</span>`
                                }
                            </div>
                            -->
                            <!-- Esto seria el taglabel 4 pra el msnje -->
                            <span>${item.meta_product_management_product_label_4 ? item.meta_product_management_product_label_4 === 'in-stock' ? 'In stock' :
                                        item.meta_product_management_product_label_4.charAt(0).toUpperCase() + 
                                        item.meta_product_management_product_label_4.slice(1) :
                                    ''
                            }</span>
                        </div>
                    </div>
                `;

                element.appendChild(productCardEngagement);
            }
            initializeEngSwiper()
            // track event recommendation action=show
            // often, the recommended items are placed below the fold, for proper evalution track "show" event after customer scrolls and see recommended items
            exponea.track("recommendation", {
                action: "show",
                item_ids: itemIds,
                recommendation_id: recommendation_id,
                placement: PLACEMENT
                // other properties: placement, ...
            });
        } else {
            document.getElementById('recommendations').innerHTML =
                'Nothing could be recommended for you!';
        }

        // add click listeners ...
        // track event recommendation action=click when item is clicked
         document.querySelectorAll(".exp-reco-product").forEach(function(item){
            item.addEventListener("click",function(){
                exponea.track("recommendation", {
                    action: "click",
                    item_id: item.dataset.productId,
                    recommendation_id: recommendation_id
        //            // other properties: placement, ...
                });
            });
         });
        }
    };

    // recommendations configuration
    var options = {
        recommendationId: recommendation_id,
        size: 10, // Specifies upper limit of the recommendations to return. Defaults to 10.
        callback: onRecommendationsLoaded,
        fillWithRandom: true, // If true, fills the recommendations with random items until size is reached. This is utilized when models cannot recommend enough items.
        // Optional parameters:
        catalogFilter: [], // Adds additional constrains to catalog when retrieving recommended items. Example: [{'property': 'gender', 'constraint': { 'type': 'string', 'operator': 'equals', 'operands': [{'type': 'constant', 'value': 'male'}]}}]
        catalogAttributesWhitelist: [], // Returns only specified attributes from catalog items. If empty or not set, returns everything.
    };
    // call recommedations
    exponea.getRecommendation(options);

    // start timeout to discard rendering when recommendations are loaded too late
    setTimeout(function () {
        if (RCM_STATUS !== "LOADED") {
            RCM_STATUS = "TIMED_OUT";
            // track event recommendation action=timeout
            exponea.track("recommendation", {
                action: "timeout",
                recommendation_id: recommendation_id
                // other required properties: placement, ...
            });
        }
    }, 5000); 

  function initializeEngSwiper() {
    const carouselEng = document.querySelector('bloomreach-products-carousel-engagement');
    if (!carouselEng) {
      return;
    }
    const carouselName = carouselEng.getAttribute('swiper-name');
    const swiperEngagement = new Swiper(`.${carouselName}`, {
        loop: false,
        observer: true,
        slidesPerView: 1.06,
        spaceBetween: 2,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 4.13,
                allowTouchMove: true,
            },
        },
    });
  }
